import ZJNotify from '../../notify';
import utils from '../../utils';

// 14 字节头（4 字节起始位 + 4 字节数据长度 + 2 字节消息类型 + 4 字节消息码 + 4 字节保留位）
const HEAD_SIZE = 18;

const CONSTS = {
    STA:        0x4D534700,
    // 消息类型
    REQUEST:    0,
    RESPONSE:   1,
    ERROR:      2,
    DATA:       3,
    MESSAGE:    4,

    // 请求码
    PING:       0,
    PONG:       1,
    ECHO:       2,
    CLOSE:      3,
    STOP:       4,
    PREVIEW:    5,
    PLAYBACK:   6,
    RESIZE:     7, //改变大小
    CTRL:       8, //控制指令
    API_PROXY:  9, //转发请求到 API
    PAUSE:      10, //暂停
    RESUME:     11, //恢复

    GET_PAGED_CAMERA_LIST   : 100, //分页获取摄像机
    GET_CAMERA_BY_ID        : 101, //根据 ID 获取摄像机
    GET_PAGED_REGION_LIST   : 102, //分页获取区域
    GET_REGION_BY_ID        : 103, //根据 ID 获取区域信息
    PTZ_CONTROL             : 104, //云台控制
    DEVICE_SNAPSHOT         : 105, //设备抓图
    GET_PRESET_LIST         : 106, //获取预置点
    SET_PRESET              : 107, //添加或更新预置点
    CLEAR_PRESET            : 108, //清空预置点

    // 消息


    // 数据
    YUV:         0,
    RGB:         1,
    CAMERA_INFO: 2, //摄像机信息
    STREAM_URL:  3, //取流地址信息
    EVENT:       4, //事件消息

    // 错误码
    OK:             0,
    ERR_EXCEPTION:  1,      // 服务异常
    ERR_INTERNAL:   2,      // 服务内部错误
    ERR_NETWORK:    3,      // 网络错误
    ERR_ARG:        100,    // 参数错误
    ERR_NOEXIST:    101,    // 摄像机不存在
    ERR_STREAM:     102,    // 取流失败
    


    // 广播参数 22 + xxxx
    Get_End_Points:2201,  // 获取所有终端
    Start_TTS: 2202, // 开始文本广播
    Stop_TTS: 2203, // 停止文本广播
    Start_Broadcast: 2204, // 发起人工广播
    Stop_Broadcast: 2205, // 停止人工广播
    Start_MP3:2206, // 开始播放MP3
    MP3_Set_Mode:2207, // 设置 MP3 播放模式
    MP3_Control:2208, // MP3 播放控制
    MP3_Play_Last:2209, // MP3 播放上一曲
    MP3_Play_Next:2210, // MP3 播放下一曲
    MP3_Play_Choose:2211, // MP3 播放选中曲目
    MP3_Seek:2212, // MP3 播放选中曲目
    MP3_List:2213, // 获取音乐列表。目前该方法仅适用于迪士普广播
    Stop_Server_Task:2214, // 停止服务器任务. (可停止当前用户发起的或其他用户发起的任务)
    Set_End_Point_Volume:2215, // 调整终端音量
    Set_Task_Volume:2216, // 调整任务音量
    Get_Error_String:2217, // 获取错误描述
    Broadcast_Callback:2218, // 获取错误描述
};

const MediaCenterMsg = function(opts) {
    opts = opts || {};
    this.dataSize = opts.dataSize || 0;
    this.msgType = opts.msgType || 0;
    this.msgCode = opts.msgCode || 0;
    this.reserve = opts.reserve || 0;
    this.msgData = opts.msgData || [];
};

const pt = MediaCenterMsg.prototype;

MediaCenterMsg.HEAD_SIZE = HEAD_SIZE;

utils.extend(MediaCenterMsg, CONSTS);
utils.extend(pt, CONSTS);

pt.isRequest = function () {
    return this.msgType == CONSTS.REQUEST;
};

pt.isResponse = function () {
    return this.msgType == CONSTS.RESPONSE;
};

pt.isData = function () {
    return this.msgType == CONSTS.DATA;
};

pt.isMsg = function () {
    return this.msgType == CONSTS.MESSAGE;
};

pt.isError = function () {
    return this.msgType == CONSTS.ERROR;
};

pt.isPing = function () {
    return this.isRequest() && this.msgCode == CONSTS.PING;
};

pt.isPong = function () {
    return this.isResponse() && this.msgCode == CONSTS.PONG;
};

pt.isCameraInfo = function () {
    return this.isData() && this.msgCode == CONSTS.CAMERA_INFO;
};

pt.isStreamUrl = function () {
    return this.isData() && this.msgCode == CONSTS.STREAM_URL;
};

pt.isYUVData = function () {
    return this.isData() && this.msgCode == CONSTS.YUV;
};

pt.isRGBData = function () {
    return this.isData() && this.msgCode == CONSTS.RGB;
};

// 转换为字节数组
pt.toArray = function() {
    return build(this);
};

// 获取文本数据
pt.getStringData = function() {
    return MediaCenterMsg.getUtf8String(this.msgData);
};

// 获取对象数据
pt.getJsonData = function() {
    const s = this.getStringData();
    if (s) {
        return JSON.parse(s);
    }
    return null;
};

// 转换为字节数组
const build = function (d) {
    if (typeof d !== "object") { // 调用模式： build(msgType, msgCode, msgData);
        let msgData = arguments[2];
        if (typeof msgData === 'string') {
            msgData = MediaCenterMsg.getUtf8Array(msgData) || [];
        }
        else if (msgData != null && typeof msgData !== 'undefined') {
            msgData = MediaCenterMsg.getUtf8Array(JSON.stringify(msgData));
        }
        else {
            msgData = [];
        }
        let msg = {
            msgType: arguments[0] || 0,
            msgCode: arguments[1] || 0,
            msgData: msgData || []
        };
        return build(msg);
    }
    else {
        /* 调用模式：
            build({
                msgType: 0,
                msgCode: 0,
                msgData: []
            });
        */
        let buf = [];
        let bytes = d.msgData || [];
        const writer = new ZJNotify.BinaryWriter(buf);
        writer.writeInt32(CONSTS.STA);        // 4 字节起始位
        writer.writeInt32(bytes.length);      // 4 字节数据长度
        writer.writeInt16(d.msgType || 0);    // 2 字节消息类型
        writer.writeInt32(d.msgCode || 0);    // 4 字节消息码
        writer.writeInt32(d.reserve || 0);    // 4 字节保留
        writer.writeArrayBuffer(bytes, 0, bytes.length); // 数据
        return buf;
    }
};

// 构建包的字节序列
MediaCenterMsg.build = build;

// 解析数据为消息
MediaCenterMsg.parse = function(data) {
    let msg = new MediaCenterMsg();
    const reader = new ZJNotify.BinaryReader(data);
    msg.sta = reader.readInt32();      // 4 字节起始位
    
    if (msg.sta != CONSTS.STA) {
        throw new Error('Invalid STA');
    }

    msg.dataSize = reader.readInt32(); // 4 字节数据长度
    msg.msgType = reader.readInt16();  // 2 字节消息类型
    msg.msgCode = reader.readInt32();  // 4 字节消息码
    msg.reserve = reader.readInt32();  // 4 字节保留
    const msgData = [];
    reader.readBuffer(msgData, 0, msg.dataSize);
    msg.msgData = msgData;
    return msg;
};

// 尝试从缓存中读取一条消息。
// 读取完成后，移动缓存的 <paramref name="offset"/> 和 <paramref name="count"/>。
// buf 必须满足如下格式：
//     {
//         buffer: [0,1,2,3...],
//         offset: 0,
//         count: 4...
//     }
MediaCenterMsg.tryParseBuffer = function (buf) {
    if (buf.count >= HEAD_SIZE) {
        const reader = new ZJNotify.BinaryReader(buf.buffer, buf.offset, buf.count);
        //4 字起始
        const sta = reader.readInt32();
        
        if (sta != CONSTS.STA) {
            throw new Error('Invalid STA');
        }

        //4 字节数据长度
        const dataSize = reader.readInt32();
        if (buf.count >= dataSize + HEAD_SIZE) {
            const msg = new MediaCenterMsg();
            msg.sta = sta;                     // 4 字起始
            msg.dataSize = dataSize;           // 4 字节数据长度
            msg.msgType = reader.readInt16();  // 2 字节消息类型
            msg.msgCode = reader.readInt32();  // 4 字节消息码
            msg.reserve = reader.readInt32();  // 4 字节保留
            const msgData = buf.buffer.subarray(
                buf.offset + HEAD_SIZE,
                buf.offset + HEAD_SIZE + msg.dataSize);
            msg.msgData = msgData;

            buf.offset += dataSize + HEAD_SIZE;
            buf.count -= dataSize + HEAD_SIZE;

            return msg;
        }
    }
    return false;
};

// 写入数据到缓存(buf)中，
// 同时通过 <paramref name="callback"/> 来消费缓存数据，
// 最终 buf 中仅保留未被消费的数据。
// 参数：
//     buf      - 写入数据到此缓存中。 buf 必须满足如下格式：
//                {
//                    buffer: [0,1,2,3...],
//                    count: 4...
//                }
//     src      - 数据源。从此源缓存中读取数据。必须满足如下格式：
//                {
//                    buffer: [0,1,2,3...],
//                    offset: 0,
//                    count: 4...
//                }
//     callback - 当读取到一个消息时的回调函数
MediaCenterMsg.writeBuffer = function (buf, src, callback) {
    if (!src || !src.count) {
        return;
    }
    
    if (buf.count == 0) {
        let msg;

        while ((msg = MediaCenterMsg.tryParseBuffer(src)) !== false) {
            callback(msg);
        }

        // 复制剩余数据到缓存
        if (src.count > 0) {
            buf.blockCopy(src.buffer, src.offset, src.count);
            return;
        }
    }
    else if (buf.count + src.count < HEAD_SIZE) { // 长度不足
        // 复制数据到缓存，等待下次接收
        buf.blockCopy(src.buffer, src.offset, src.count);
        return;
    }
    else {
        //如果缓存中的数据不足一个包头的话，则复制包头到缓存中，
        //因此可以读取到完整的数据长度。
        if (buf.count < HEAD_SIZE) {
            let n = HEAD_SIZE - buf.count; //还需要多少数据才能构成一个完整包头
            buf.blockCopy(src.buffer, src.offset, n);
            src.offset += n;
            src.count -= n;
        }

        const reader = new ZJNotify.BinaryReader(buf.buffer, 0, buf.count);
        const sta = reader.readInt32(); // 4 字节起始位
        
        if (sta != CONSTS.STA) {
            throw new Error('Invalid STA');
        }

        const dataSize = reader.readInt32(); // 4 字节数据长度

        if ((buf.count + src.count) >= (dataSize + HEAD_SIZE)) {

            const msg = new MediaCenterMsg();
            msg.sta = sta;                     // 4 字节起始位
            msg.dataSize = dataSize;           // 4 字节数据长度
            msg.msgType = reader.readInt16();  // 2 字节消息类型
            msg.msgCode = reader.readInt32();  // 4 字节消息码
            msg.reserve = reader.readInt32();  // 4 字节保留
            
            const msgData = new utils.Buffer(dataSize);

            const sizeInBuffer = buf.count - HEAD_SIZE; // 在缓存中的数据大小
            const sizeInSrc = dataSize - sizeInBuffer; //在 src 中的数据长度
            
            //先从缓存中复制数据
            msgData.blockCopy(buf.buffer, HEAD_SIZE, sizeInBuffer);

            //然后从 src 中复制剩余数据
            msgData.blockCopy(src.buffer, src.offset, sizeInSrc);

            msg.msgData = msgData.buffer;

            src.offset += sizeInSrc;
            src.count -= sizeInSrc;
            buf.count = 0;

            callback(msg);

            if (src.count > 0) {
                //处理剩余数据
                MediaCenterMsg.writeBuffer(buf, src, callback);
            }
            return;
        }
        else {
            // 复制数据到缓存，等待下次接收
            buf.blockCopy(src.buffer, src.offset, src.count);
            return;
        }
    }
};

// 获取字符串的 UTF8 字节码
MediaCenterMsg.getUtf8Array = function(s) {
    return utils.stringToUtf8ByteArray(s || "") || [];
};

// 获取 UTF8 字节码对应的字符串 
MediaCenterMsg.getUtf8String = function(arr) {
    return utils.utf8ByteArrayToString(arr || []) || "";
};

export default MediaCenterMsg;
